import * as z from 'zod'

export const ContactSchema = z.object({
    name: z.string().min(1, { message: 'Name is required' }),
    email: z.string().email({ message: 'Invalid email address' }),
    message: z.string().min(1, { message: 'Message is required' }),
    topicSelection: z.string().min(1, { message: 'Topic is required' }),
    privacyPolicy: z.boolean().refine((val) => val === true, {
        message: 'You must accept the privacy policy'
    })
})
